import * as React from "react";
import { QnaResult } from "../types";
import Carousel from "./Carousel";

interface Props {
  data: QnaResult;
}

export default function QnaResultView({ data }: Props) {
  return (
    <div>
      <Carousel itemsPerSlide={1}>
        {data.Answers.map((result, i) => (
          <div className="qna-answer-item" key={i}>
            <div className="qna-question">
              <b>{result.Question}</b>
            </div>
            <i className="qna-answer">
              <div dangerouslySetInnerHTML={{ __html: result.Answer }} />
            </i>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
